<template>
  <div class="action">
    <CCard class="question_form">
      <CCardHeader align="center">
        <strong>Questionnaire </strong><small>Form</small>
      </CCardHeader>

<!--      Question-->
      <CCardBody class="dyn"  >
        <CRow v-for="(question, counter) in questionnaire" v-bind:key="counter">
          <CCol sm="8">
            <label>Question # {{counter}} </label>
            <CTextarea
                v-model="question.question"
                placeholder="Input your question here"
            />
          </CCol>
          <CCol sm="4">
            <div>
              <CButton type="submit" color="dark" @click="addQuestion()">AddQ</CButton>
              <CButton type="reset" color="dark" @click="removeQuestion()">RemoveQ</CButton>
            </div>
          </CCol>
        </CRow>

<!--        Choice-->
        <CRow v-for="(choice, counter) in choices" v-bind:key="counter">
          <CCol sm="8">
            <CInput
                v-model="choice.choice"
                type="text"
                description="Choice"
                label="Choice A"
                horizontal
                placeholder="Choice A"
            />
          </CCol>
          <CCol sm="4">
            <div>
              <CButton type="submit" color="dark" @click="addChoice()">AddC</CButton>
              <CButton type="reset" color="dark" @click="removeChoice()">RemoveC</CButton>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
      <CCardFooter>
        <div class="card_footer">
          <CButton type="submit" class="mx-3" color="primary" @click="addQuestion()">Add</CButton>
          <CButton type="reset" class="mx-3" color="danger" @click="removeQuestion()">Remove</CButton>
        </div>
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
export default {
  name: "QuestionForm",
  data() {
    return {
      questionnaire: [
        {
          question: ''
        }
      ],
      choices :[
        {
          choice: ''
        }
      ]
    }
  },
  mounted() {
    document.title = 'Starter Grower | Questionnaire'
  },
  methods: {
    addQuestion() {
      this.questionnaire.push({
        question: ''
      })
      this.addChoice()
    },
    removeQuestion(counter) {
      this.questionnaire.splice(counter,1);
    },
    addChoice() {
      this.choices.push({
        choice: ''
      })
    },
    removeChoice(count) {
      this.choices.splice(count,1);
    }
  }
}
</script>

<style scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: center;
  /*height: 100vh;*/
}
.card_footer {
  justify-content: center;
  display: flex;
}
.question_form {
  min-width: 50%;
}

</style>
